const digest = 'e1c9691d6d4015cce0997a13c5dc35c348ab45cb656bd4fe30dbd4f0c5545bb2';
const css = `._hiddenAccessibilityButton_bgm3a_1{background-color:#fbfbfb;height:3.125rem;outline-color:transparent}._hiddenAccessibilityButton_bgm3a_1 ._fakeInputWrapper_bgm3a_6{cursor:text;height:3rem;hyphens:auto;padding:.75rem}._hiddenAccessibilityButton_bgm3a_1:focus{outline-color:#006fcf}._hiddenAccessibilityButton_bgm3a_1._hasWarning_bgm3a_15,._hiddenAccessibilityButton_bgm3a_1._hasWarning_bgm3a_15:focus{border-color:#b41601}[data-dls-surface=fg-brand] ._hiddenAccessibilityButton_bgm3a_1{background-color:#0066be}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'hiddenAccessibilityButton': '_hiddenAccessibilityButton_bgm3a_1', 'fakeInputWrapper': '_fakeInputWrapper_bgm3a_6', 'hasWarning': '_hasWarning_bgm3a_15' };
export const hiddenAccessibilityButton = '_hiddenAccessibilityButton_bgm3a_1';
export const fakeInputWrapper = '_fakeInputWrapper_bgm3a_6';
export const hasWarning = '_hasWarning_bgm3a_15';
export { css, digest };